<template>

  <div class="ue-expenses-edit">
    <el-card>
      <div class="header">
        <h2>123-2.1.2.2.4.1.2 огпо транспорт  (Год: {{ dto.trancheYear }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="isLoading" v-if="dto.status !== 'APPROVED' && hasEditPermission()">Сохранить</el-button>
        </div>
      </div>

      <form >

        <div class="table-container">

          <table class="grid-table">
            <thead>
            <tr>

              <th  class="title-cell" rowspan="2">Тип транспортного средства</th>
              <th rowspan="2">Размер Коэффициента по типу транспортного средства *</th>
              <th v-for="region in regions" :key="'h-'+region.id">{{region.nameRu}}</th>
              <th rowspan="2">Расчетная  сумма	</th>
              <th rowspan="2">Фактическая  сумма</th>
            </tr>
            <tr>
              <th v-for="region in regions" :key="'hq-'+region.id">
                Количество транспортных средств
              </th>
            </tr>
            </thead>
            <tbody>
            <tr class="total-row calculated-row readonly-text">
              <td>ВСЕГО</td>
              <td></td>
              <td v-for="region in regions" :key="'t-'+region.id">{{ formatNum(dto.regions ? dto.regions[region.id] : '') }}</td>
              <td>{{ formatNum(dto.calculatedSum) }}</td>
              <td>{{ formatNum(dto.actualSum) }}</td>
            </tr>

            <tr v-for="month in dto.months" :key="'m-'+month.month">
              <td>{{ months[month.month - 1] }}</td>
              <td></td>
              <td class="readonly-text" v-for="region in regions" :key="'mr-'+region.id"></td>
              <td class="readonly-text">{{ formatNum(month.calculatedSum) }}</td>
              <td class="expense-sum-edit">
                <el-input v-model="month.actualSum" type="number" min="0" @input="onMonthActualSumInput(month)"/>
              </td>
            </tr>

            <template v-for="(cat, index) in dto.categories" :key="cat.uuid || index">
              <tr class="total-row calculated-row">
                <td class="title-cell">
                  <div class="d-flex align-items-center">
                  <b>{{ categories[cat.type] }}</b>
                  <el-button type="danger" size="small" style="margin-left: 5px;" @click="onClickRemove(cat)" v-if="dto.status !== 'APPROVED' && hasEditPermission()">
                    <font-awesome-icon :icon="['fas', 'trash']" />
                  </el-button>
                  </div>
                </td>
                <td></td>
                <td class="readonly-text" v-for="region in regions" :key="'cr-'+region.id">
                    {{ formatNum(cat.regions ? cat.regions[region.id] : '') }}
                </td>
                <td class="readonly-text">{{ formatNum(cat.calculatedSum) }}</td>
                <td class="readonly-text"></td>
              </tr>
              <tr v-for="item in cat.items" :key="item.uuid || item.type">
                <td class="title-cell"><b>{{ categories[cat.type] }} {{categoryItems[item.type]}}</b></td>
                <td>
                  <el-input v-model="item.rate" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="expense-sum-edit" v-for="region in regions" :key="'ir-'+region.id">
                  <el-input v-model="item.regions[region.id]" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="readonly-text">{{ formatNum(item.calculatedSum) }}</td>
                <td class="readonly-text"></td>
              </tr>
            </template>

            </tbody>

          </table>
        </div>


      </form>

      <div class="d-flex align-items-center" v-if="dto.status !== 'APPROVED' && hasEditPermission()">
        <div class="mb-3">
        <el-select v-model="selectedCategory" placeholder="Выберите" size="small" style="width: 200px" >
          <el-option v-for="(value) in getNotAddedCategories()" :key="value" :label="categories[value]" :value="value"></el-option>
        </el-select>
      </div>

      <div class="mb-3" >
        <el-button type="success" size="small" @click="addRow" :disabled="!selectedCategory">
          <font-awesome-icon :icon="['fas', 'plus']"/> Добавить категорию
        </el-button>
      </div>
      </div>
      </el-card>
  </div>


  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import authService from "@/services/authService";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";
import regionService from "@/services/regionService";

export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      expenseType: 'insurance-transport',
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        months: [],
        categories: [],
      },
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      selectedCategory: null,
      categories: {
        PASSENGER: "Легковые",
        BUS_UP_TO_16_SEATS: "Автобусы до 16 мест включительно",
        BUS_OVER_16_SEATS:" Автобусы свыше 16 мест",
        TRUCK: "Грузовые",
        ELECTRIC_TRANSPORT:"Троллейбусы и трамваи",
        MOTORCYCLE: "Мототранспорт",
        TRAILER: "Прицепы"
      },
      categoryItems: {
        UP_TO_7_YEARS: "(до 7 лет)",
        MORE_THAN_7_YEARS: "(свыше 7 лет)"
      },
      regions: [],
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
    };
  },
  methods: {
    async init() {
      this.isLoading = true;
      try {
        await this.findById(this.uuid);
        await this.getRegions();
        this.recalculateAll();
      } finally {
        this.isLoading = false;
      }
    },

    async getRegions() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      const response = await regionService.getAll(params);
      this.regions = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
    },

    getNotAddedCategories() {
      if (!this.dto.categories) {
        return this.categories;
      }
      if (this.dto.categories.length >= Object.keys(this.categories).length) {
        return [];
      }
      const addedItems = this.dto.categories.map(c => c.type);
      return Object.keys(this.categories).filter(key => !addedItems.includes(key));
    },

    initFrontendFields() {
      this.dto.regions = {};
      this.dto.calculatedSum = 0;
      this.dto.actualSum = 0;

      if (this.dto.categories) {
        for (const cat of this.dto.categories) {
          cat.regions = {};
          cat.calculatedSum = 0;
          for (const item of (cat.items || [])) {
            if (!item.regions) item.regions = {};
          }
        }
      }

      if (this.dto.months) {
        for (const month of this.dto.months) {
          if (!month.regions) month.regions = {};
        }
      }
    },

    async findById(uuid) {
      this.dto = await ueExpensesCommonCrudService.findById(this.expenseType, uuid);
      this.initFrontendFields();
      this.sortByCatAndMonth();
    },

    async submitForm() {
      try {
        if (!this.hasEditPermission()) return;
        this.isLoading = true;
        this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
        this.initFrontendFields();
        this.sortByCatAndMonth();
        this.recalculateAll();
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },

    sortByCatAndMonth() {
      if (!this.dto.categories) return;
      const order = Object.keys(this.categories);
      this.dto.categories.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type));
      if (this.dto.months) {
        this.dto.months.sort((a, b) => a.month - b.month);
      }
    },

    recalculateAll() {
      if (!this.dto.categories) return;

      let totalCalcSum = 0;
      const totalRegions = {};

      for (const cat of this.dto.categories) {
        const catRegions = {};
        let catCalcSum = 0;

        for (const item of (cat.items || [])) {
          const rate = Math.max(0, parseFloat(item.rate || 0));

          let itemRegionSum = 0;
          for (const region of this.regions) {
            const val = Math.max(0, parseFloat(item.regions[region.id] || 0));
            itemRegionSum += val;
            catRegions[region.id] = (catRegions[region.id] || 0) + val;
          }

          item.calculatedSum = rate * itemRegionSum;
          catCalcSum += item.calculatedSum;
        }

        cat.regions = catRegions;
        cat.calculatedSum = catCalcSum;
        totalCalcSum += catCalcSum;

        for (const regionId of Object.keys(catRegions)) {
          totalRegions[regionId] = (totalRegions[regionId] || 0) + catRegions[regionId];
        }
      }

      this.dto.regions = totalRegions;
      this.dto.calculatedSum = totalCalcSum;

      const monthCalcSum = Math.round(totalCalcSum / 12 * 100) / 100;
      for (const month of (this.dto.months || [])) {
        month.calculatedSum = monthCalcSum;
        month.actualSum = monthCalcSum;
      }

      this.dto.actualSum = (this.dto.months || []).reduce(
        (sum, m) => sum + parseFloat(m.actualSum || 0), 0
      );
    },

    onMonthActualSumInput(month) {
      if (parseFloat(month.actualSum) < 0) {
        month.actualSum = 0;
      }
      this.dto.actualSum = (this.dto.months || []).reduce(
        (sum, m) => sum + parseFloat(m.actualSum || 0), 0
      );
    },

    formatNum(val) {
      if (val === undefined || val === null || val === '') return '';
      const num = parseFloat(val);
      if (isNaN(num)) return '';
      if (num === 0) return '0,00';
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',');
    },

    goBack() {
      this.$router.go(-1);
    },

    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED' || !this.dto.status);
    },

    isUniversityManager() {
      return delegationService.isUniversityManager();
    },

    addRow() {
      this.dto.categories.push({
        type: this.selectedCategory,
        items: [
          { type: 'UP_TO_7_YEARS', rate: 0, regions: {}, calculatedSum: 0, actualSum: 0 },
          { type: 'MORE_THAN_7_YEARS', rate: 0, regions: {}, calculatedSum: 0, actualSum: 0 }
        ],
        regions: {},
        calculatedSum: 0,
        actualSum: 0
      });
      this.selectedCategory = null;
      this.recalculateAll();
    },

    async onClickRemove(category) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await ueExpensesCommonCrudService.deleteCategory(this.expenseType, this.uuid, category.uuid);
          this.init();
          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

table.expenses-detail tr td {
  padding: 0 !important;
  padding-left: 5px !important;
  font-size: 14px;
}
table.expenses-detail tr td.expense-sum-edit:has(.form-control){
  padding-left: 0 !important;
}

table.expenses-detail tr td.expense-sum-edit .form-control {
  padding-left: 2px !important;
  font-size: 14px !important;
}
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.table-container { width: 100%; overflow-x: auto; }
.grid-table { width: 100%; border-collapse: collapse; min-width: 1200px; }
.grid-table th, .grid-table td { border: 1px solid #EBEEF5; padding: 8px; font-size: 13px; }
.grid-table th { background-color: #f5f7fa; text-align: center; font-weight: bold; position: sticky; top: 0; z-index: 10; }
.title-cell { width: 350px; }
.color-red, .color-red:hover {  color: red !important;}
.calculated-row { background-color: #f0f9eb; font-weight: bold; }
.readonly-text { text-align: right; padding-right: 10px !important; }
::v-deep .el-input__inner { text-align: right; font-size: 13px; -moz-appearance: textfield; }
::v-deep .el-input__inner::-webkit-outer-spin-button,
::v-deep .el-input__inner::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.total-row td {
  font-weight: bold;
}
</style>
